
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPWardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPWardNameDDL = (props) => {
    const { WTPWardNameDDLID, setWTPWardNameDDLID, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: 0,
            M_UserID: UserID,
            token: token,
            Flag: Flag
        }
        dispatch(WTPWardNameDDLAPI({ data }))
    }, [])

    const { WTPWardNameData } = useSelector(state => state.WTPWardNameDDLData)

    useEffect(() => {
        handleWorkAssignByDDL()
    }, [WTPWardNameData])

    const handleWorkAssignByDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPWardNameData && WTPWardNameData.table && WTPWardNameData.table.length > 0) {
            let list = WTPWardNameData.table.map((item, index) => ({
                value: item.m_WardID,
                label: item.wardName,
            }))

            setWTPWardNameDDLID({
                ...WTPWardNameDDLID,
                DDL: list,
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setWTPWardNameDDLID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }


    }

    return (
        <div className="form-group">
            <Select
                isClearable
                isSearchable
                maxMenuHeight={150}
                value={{ value: WTPWardNameDDLID.ID, label: WTPWardNameDDLID.Label }}
                onChange={(e) => {
                    e ?
                        setWTPWardNameDDLID({ ...WTPWardNameDDLID, ID: e.value, Label: e.label })
                        :
                        setWTPWardNameDDLID({ ...WTPWardNameDDLID, ID: 0, Label: "Select..." })

                }}
                options={WTPWardNameDDLID.DDL}
            />
        </div>
    )
}